import { api } from 'services/api'

export const alterarStatus = async (data) => {
  const url = 'faturas/updateStatus'

  const response = await api.patch(`${url}/${data.id}`, { data })

  return response.data.data
}